<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i> Webshell

        <span class="float-right">
          * Webshell files must be approved as actual patterning before they are distributed as detection policies
        </span>
      </template>

      <b-tabs v-model="index">
        <b-tab title="Waiting for approval" active>
          <WaitTable ref="wait" @refresh="refresh"/>
        </b-tab>
        <b-tab title="History">
          <HistoryTable ref="history" @refresh="refresh"/>
        </b-tab>
        <b-tab title="Summary">
          <Summary ref="summary" @refresh="refresh" />
        </b-tab>

      </b-tabs>

    </b-card>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import datepicker from '@/f1/custom';
import { api, auth } from '@/f1/service';
import 'vue2-datepicker/index.css';
import moment from 'moment-timezone';

// component
import WaitTable from './Webshell.1.Wait.vue';
import HistoryTable from './Webshell.2.History.vue';
import Summary from './Webshell.Summary.vue';

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt: {
    created_at_ed: moment().add(1, 'd'),
    created_at_sd: moment().add(1, 'd'),
  }, adv: false,
  pageoptions: [
    { text: '1 rows', value: 1 },
    { text: '10 rows', value: 10 },
    { text: '25 rows', value: 25 },
    { text: '50 rows', value: 50 },
    { text: '100 rows', value: 100 },
    { text: '200 rows', value: 200 }
  ]
});

export default {
  components: { DatePicker, WaitTable, HistoryTable, Summary },
  data: () => ({
    index: 2,
    family: [
      { text: '-', value: '' },
    ],
    model: {
      family : ''
    },
    datepicker,
    so: default_opt(),
    profile: auth.profile
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', thStyle: 'width: 10%', sortable: true, label: 'No' },
        { key: 'is_alive', sortable: true, label: 'Enable' },
        { key: 'file_hash', sortable: true, label: 'Hash(md5)' },
        { key: 'extension', sortable: true, label: 'Extenstion' },
        { key: 'extension_category', sortable: true, label: 'Ext Category' },
        { key: 'origin', sortable: true, label: 'From' },
        { key: 'created_at', sortable: true, label: 'Registed_at' }
      ]
    }
  },
  methods: {

    resetField() { this.so = default_opt(); this.refresh(); this.so.adv = !this.so.adv },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      switch (this.index) {
        case 0: this.$refs.upload._list.refresh(); break;
        case 1: this.$refs.crawler._list.refresh(); break;
        case 2: this.$refs.regex._list.refresh(); break
      }
    },
    getRowCount() { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok: ctx.sortBy,
        od: ctx.sortDesc ? 'd' : 'a',
        pg: ctx.currentPage || this.so.currentPage || 1,
        pc: ctx.perPage || this.so.perPage || 10,
        sk: this.so.sk || 'site',
        sv: (this.so.sv || '').trim(),
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, and: [ { name: 'is_clear', op: '=', value: false }, { name: 'user_id', op: '=', value: 0 } ], or: [], sort: [] }
      // order
      if (so.ok) { search.sort.push({ name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search

      if (so.sk && so.sv) {
        if (!so.ok) {
          search.sort.push({ name: so.sk, op: so.od == 'd' && 'desc' });
        }
        search.or.push({ name: so.sk, value: `%${so.sv.trim()}%`, op: 'like' });
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        if (value != null && value != "") {
          switch (key) {
            case 'created_at_sd': search.and.push({ name: 'created_at', value: new Date(value), op: '>=' }); break;
            case 'created_at_ed': var d = new Date(value); d.setDate(d.getDate() + 1); search.and.push({ name: 'created_at', value: d, op: '<' }); break;
            default: search.and.push({ name: key, value: `%${value}%`, op: 'like' }); break;
          }
        }
      }

      try { let rs = await api.dms.webshell.list(search); this.so.totalRows = rs.count; return rs.result; }
      catch (e) { this.$toastr.e(e.data || e); };
    },
    detail(item) { this.$router.push({ name: 'cti_webshell', params: { id: item.id } }); },
  },
  created() { },
  destroyed() { },
  mounted() {  },
}
</script>
